import { useNavigate } from "react-router-dom";

function CategoryCard({ title, image, description, hamperType }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/build", {
      state: { hamperType },
    });
  };

  return (
    <div className="bg-white shadow rounded overflow-hidden hover:shadow-lg transition">
      <img src={image} alt={title} className="w-full h-72 object-cover" />
      <div className="p-6 text-center">
        <h3 className="text-xl font-semibold">{title}</h3>
        <p className="text-gray-500 mt-2">{description}</p>
        <button
          className="mt-4 w-full bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition font-medium"
          onClick={handleClick}
        >
          Start Building
        </button>
      </div>
    </div>
  );
}

export default CategoryCard;

